// EkBharatShreshthaBharat
import React from 'react';
import NationalUnity2023 from 'views/EkBharat2023/NationalUnity2023';
// import NationalUnity2023 from 'views/NationalUnity2023';

const EkBharatShreshthaBharatPage = () => {
  return <NationalUnity2023 />;
};

export default EkBharatShreshthaBharatPage;